import { intersection, isEmpty } from 'lodash'

export default function doesMatchMultiFilter<
  KeyToFilterGroups extends string,
  FilterValue,
  Item
>(
  selectedFilters: Record<KeyToFilterGroups, FilterValue[]>,
  getValues: (item: Item, key: KeyToFilterGroups) => FilterValue[]
): (item: Item) => boolean {
  return function predicate(item: Item): boolean {
    // Annoying that we seem to need the cast?
    return (Object.keys(selectedFilters) as KeyToFilterGroups[]).every(
      key =>
        isEmpty(selectedFilters[key]) ||
        intersection(selectedFilters[key], getValues(item, key)).length > 0
    )
  }
}
